import Cart from "../components/cart/Cart";
import { useEffect } from "react";
import "../components/cart/cart.css";
import { cartActions } from "../store/cart-slice";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import baseUrl from "../url/baseUrl";

// component trang giỏ hàng
function CartPage() {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items);
  const totalPrice = useSelector((state) => state.cart.totalPrice);
  const isLogin = useSelector((state) => state.loginUser.isLogin);

  useEffect(() => {
    document.title = "Cart";
  }, []);

  useEffect(() => {
    if (isLogin) {
      const getCart = async () => {
        try {
          const response = await fetch(baseUrl + "/get-cart", {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });

          if (response.status === 404) {
            throw new Error("Cannot show the cart");
          }

          if (response.status !== 200) {
            throw new Error("Not yet login or server error");
          }

          const data = await response.json();

          dispatch(cartActions.updateCartItems(data));
          // cal for totalPrice
          const priceArr = data.map((prod) => +prod.totalPriceOfProduct);
          dispatch(
            cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
          );
        } catch (err) {
          console.log(err);
        }
      };
      getCart();
    } else {
      const unLogCart = JSON.parse(localStorage.getItem("unLogCart")) || [];
      dispatch(cartActions.updateCartItems(unLogCart));
      // cal for totalPrice
      const priceArr = unLogCart.map((prod) => +prod.totalPriceOfProduct);
      dispatch(
        cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
      );
    }
  }, []);

  return (
    <section className="cartPage">
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/products">Sản phẩm</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Giỏ hàng
          </li>
        </ol>
      </nav>
      <div>
        <h3 className="text-success ms-3">Giỏ hàng</h3>
      </div>

      {cart.length === 0 && (
        <p className="text-danger text-center fst-italic">
          Hiện vẫn chưa có sản phẩm nào trong giỏ hàng của bạn. Bạn hãy lựa chọn
          sản phẩm cho mình nhé! 🎁
        </p>
      )}
      {cart.length !== 0 && <Cart cartArr={cart} totalPrice={totalPrice} />}
    </section>
  );
}

export default CartPage;
